import {ApiService} from "../services/api.service";

export function isIcureApiInitialized(icureApi: ApiService): boolean {
  return Boolean(
    icureApi?.userApi
  );
}
